import React, { useState } from 'react';
import { servicesImages } from '../../../config';
import withAnimation from '../../../hooks/withAnimation';
import {routeNames} from '../../../routes/routeNames'
import { useNavigate } from 'react-router-dom';
import { newServices } from '../../../utils/NewData';

const services = [
    {
      title: 'Pain Management',
      description: 'Comprehensive care for arthritis, chronic pain, neck pain, back pain, and sciatica pain.',
      image: servicesImages.arthritis
    },
    {
      title: 'Rehabilitation',
      description: 'Post-surgical rehab, pre-surgical rehab, sports injuries, workplace injuries, and motor vehicle accidents.',
      image: servicesImages.rehabilition
    },
    {
      title: 'Musculoskeletal Health',
      description: 'Comprehensive care for shoulder, hip, knee, elbow, wrist, hand, foot, and ankle pain.',
      image: servicesImages.musculoskelethalhealth
    },
    {
      title: 'Neurological Disorders',
      description: 'Specialized treatments for neurological disorders, vertigo, dizziness, balance, and gait training.',
      image:servicesImages.neurologicaldisorder
    },
    {
      title: 'Therapy Services',
      description: 'Physiotherapy, massage therapy, acupuncture, and chiropractic services.',
      image: servicesImages.therapyservices
    },
    {
      title: 'Head, Neck, and Jaw Health',
      description: 'Effective treatments for headaches and TMJ dysfunction.',
      image: servicesImages.neck
    },
    {
      title: 'Women\'s Health',
      description: 'Therapies to manage incontinence and pelvic pain.',
      image:servicesImages.womenshealth
    },
    {
      title: 'Workplace Health',
      description: 'Programs to improve ergonomics and treat workplace injuries.',
      image: servicesImages.workplacehealth
    },
    {
      title: 'Specialized Care',
      description: 'Rehabilitation for vestibular disorders and treatments for stress fractures.',
      image:servicesImages.specializedcare
    }
  ];
const Services = () => {
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate()

  return (
    <section className="bg-background py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl text-primary pb-4 font-bold text-center mb-8 lg:text-4xl">Our Services</h2>
        <p className="text-center text-lg mb-12">Find the care you need to achieve your goals.</p>
        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 overflow-hidden transition-max-height duration-500 ease-in-out ${showAll ? 'max-h-full' : 'max-h-[800px]'}`}>
          {newServices.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden transition transform duration-500 ease-in-out hover:-translate-y-1 hover:scale-105">
              <img src={service.image} alt={service.title} className="w-full h-48 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                <p className="text-gray-600 text-justify">{service.captionDescription}</p>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="text-center mt-12">
          <button
            onClick={() => navigate(routeNames.services)}
            className="bg-primary hover:bg-primary-dark text-white py-2 px-4 rounded-full font-semibold transition"
          >
             Additional Services
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default withAnimation(Services);
